import { z } from 'zod';

// Envio direto do navegador ao S3 (RQ-ARQ-003): o servidor assina a URL com o tamanho e o hash declarados;
// o S3 recusa o que não bate; depois o servidor confere o objeto e só então o arquivo passa a valer.

/** SHA-256 em base64 (como o S3 espera no cabeçalho x-amz-checksum-sha256). */
const sha256Base64 = z.string().regex(/^[A-Za-z0-9+/]{43}=$/);

export const esquemaPedirEnvio = z.object({
  nome: z.string().trim().min(1).max(255),
  mime: z.string().trim().min(1).max(150),
  tamanhoBytes: z.number().int().positive(),
  sha256: sha256Base64,
});
export type PedirEnvioEntrada = z.infer<typeof esquemaPedirEnvio>;

/** O navegador faz PUT do arquivo em `url` com exatamente estes cabeçalhos e depois confirma com `referencia`. */
export type EnvioDiretoDto = { referencia: string; url: string; cabecalhos: Record<string, string>; expiraEmSegundos: number };

export const esquemaConfirmarAvatar = z.object({ referencia: z.string().min(1).max(500) });

export type AnexoDto = { uuid: string; nome: string; mime: string; tamanhoBytes: number };

/** Anexos por post-it (RQ-NOT-009). */
export const LIMITE_ANEXOS_NOTA = 2;

/** Foto de perfil: imagem de até 2 MB. */
export const LIMITE_AVATAR_BYTES = 2 * 1024 * 1024;
